export default __webpack_public_path__ + "678cf51d2e6d847084e46cb4546564ca.png";